import { Divider, Grid, Typography } from '@mui/material';
import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { getValueOrDefault } from '../../../../../utils/constants';

interface VariableToVariableActionProps {
    actionData: any,
} 

const VariableAssignmentAction: React.FC<VariableToVariableActionProps> = (props) => {

    const { actionData } = props;
    const { saved_variables } = actionData || {};

    const checkIfStaticValueAssignment = () => {
        return !saved_variables?.source_chatbot_custom_variable_configuration_name;
    }

    const getVariableValue = () => {
        let variableValue;
        if(checkIfStaticValueAssignment()){
            variableValue = getValueOrDefault(saved_variables?.variable_value);
        } else {
            variableValue = getValueOrDefault(saved_variables?.source_chatbot_custom_variable_configuration_name);
        }

        return variableValue;
    }
    
    return (
        <>
            <Grid container className={`${styles.saveVariableToVariableActionMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>Variable Assignment</Typography>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"6px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={5} className={styles.customAPICallInfoTitle}>
                            {checkIfStaticValueAssignment() ? "Static Value" : "Source Variable"}    
                        </Grid> 
                        <Grid item xs={6.5}>
                            {getVariableValue()}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"6px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={5} className={styles.customAPICallInfoTitle}>
                            Target Variable    
                        </Grid> 
                        <Grid item xs={6.5}>
                            {saved_variables?.destination_chatbot_custom_variable_configuration_name || "-"}
                        </Grid>
                    </Grid>
                </Grid> 

                {!checkIfStaticValueAssignment() &&
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container gap={"6px"} flexWrap={"nowrap"} alignItems={"center"}>
                            <Grid item xs={5} className={styles.customAPICallInfoTitle}>
                                Value    
                            </Grid> 
                            <Grid item xs={6.5}>
                                {saved_variables?.variable_value || "-"}
                            </Grid>
                        </Grid>
                    </Grid>
                }

            </Grid>
        </>
    )
}

export default VariableAssignmentAction
